/* Conimar sections — scroll reveals + process tabs.
   Runs on the storefront and inside the Shopify theme editor. */
(function () {
  function initReveals(root) {
    var items = (root || document).querySelectorAll(".cn-reveal:not([data-cn-revealed])");
    if (!items.length) return;

    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) {
        el.classList.add("is-visible");
        el.setAttribute("data-cn-revealed", "true");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute("data-cn-delay") || "0", 10);
          setTimeout(function () {
            el.classList.add("is-visible");
          }, delay);
          observer.unobserve(el);
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.15 }
    );

    items.forEach(function (el) {
      el.setAttribute("data-cn-revealed", "true");
      observer.observe(el);
    });
  }

  function initTabs(root) {
    var groups = (root || document).querySelectorAll("[data-cn-tabs]:not([data-cn-ready])");
    groups.forEach(function (group) {
      group.setAttribute("data-cn-ready", "true");
      var tabs = group.querySelectorAll("[data-cn-tab]");
      var panels = group.querySelectorAll("[data-cn-panel]");
      var steps = group.querySelectorAll("[data-cn-step]");

      function select(index) {
        tabs.forEach(function (tab, i) {
          tab.setAttribute("aria-selected", i === index ? "true" : "false");
        });
        panels.forEach(function (panel, i) {
          panel.hidden = i !== index;
        });
        steps.forEach(function (step, i) {
          step.setAttribute("data-current", i === index ? "true" : "false");
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener("click", function () {
          select(i);
        });
      });

      select(0);
    });
  }

  function init(root) {
    initReveals(root);
    initTabs(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor: re-init when a section is added, moved, or re-rendered.
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
